import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommCoinsIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.7349 6C14.7349 5.58579 14.3991 5.25 13.9849 5.25C13.5707 5.25 13.2349 5.58579 13.2349 6V6.24133C12.2128 6.52432 11.3878 7.37217 11.3878 8.50223C11.3878 9.09264 11.5613 9.69258 12.09 10.1141C12.5801 10.5049 13.2477 10.6349 13.9849 10.6349C14.5987 10.6349 14.8988 10.7457 15.0379 10.8531C15.1337 10.9271 15.25 11.0729 15.25 11.4981C15.25 11.8489 15.1282 12.0168 14.9752 12.1255C14.7842 12.2613 14.4549 12.3613 13.9849 12.3613C13.2343 12.3613 12.8019 11.9344 12.7327 11.6178C12.6444 11.2131 12.2447 10.9567 11.84 11.045C11.4353 11.1334 11.1789 11.5331 11.2673 11.9378C11.4753 12.8908 12.2886 13.5444 13.2349 13.7722V14C13.2349 14.4142 13.5707 14.75 13.9849 14.75C14.3991 14.75 14.7349 14.4142 14.7349 14V13.796C15.1304 13.723 15.5138 13.5831 15.8444 13.3481C16.4207 12.9383 16.75 12.2996 16.75 11.4981C16.75 10.771 16.5304 10.1103 15.9545 9.66575C15.422 9.25463 14.7146 9.13495 13.9849 9.13495C13.3788 9.13495 13.1228 9.01911 13.0251 8.94128C12.9661 8.89417 12.8878 8.80275 12.8878 8.50223C12.8878 8.11771 13.2803 7.63906 13.9849 7.63906C14.6033 7.63906 14.9994 8.0226 15.069 8.36959C15.1504 8.77573 15.5456 9.03899 15.9517 8.9576C16.3579 8.87621 16.6211 8.481 16.5397 8.07486C16.3556 7.15587 15.6244 6.48458 14.7349 6.24016V6Z"
            fill="#222"
          />
          <path
            d="M14 1.25C9.16751 1.25 5.25 5.16751 5.25 10C5.25 14.8325 9.16751 18.75 14 18.75C18.8325 18.75 22.75 14.8325 22.75 10C22.75 5.16751 18.8325 1.25 14 1.25ZM6.75 10C6.75 5.99594 9.99594 2.75 14 2.75C18.0041 2.75 21.25 5.99594 21.25 10C21.25 14.0041 18.0041 17.25 14 17.25C9.99594 17.25 6.75 14.0041 6.75 10Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M3.78413 11.4107C4.01095 11.0641 3.91385 10.5993 3.56726 10.3724C3.22066 10.1456 2.75582 10.2427 2.52901 10.5893C1.72021 11.8252 1.25 13.3033 1.25 14.8888C1.25 19.2304 4.76956 22.75 9.11116 22.75C10.6967 22.75 12.1748 22.2798 13.4107 21.471C13.7573 21.2442 13.8544 20.7793 13.6276 20.4327C13.4007 20.0862 12.9359 19.9891 12.5893 20.2159C11.5901 20.8698 10.3962 21.25 9.11116 21.25C5.59799 21.25 2.75 18.402 2.75 14.8888C2.75 13.6038 3.13024 12.4099 3.78413 11.4107Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
